import {Component, OnInit, ViewChild} from '@angular/core';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {NgxSpinnerService} from "ngx-spinner";
import {RilrService} from '../services/rilr.service';
import {HelperService} from '../services/helper.service';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import {IOption} from 'ng-select';
import {Location} from "@angular/common";

@Component({
  selector: 'app-corrective-action-almaha-modal',
  templateUrl: './corrective-action-almaha-modal.component.html',
  styleUrls: ['./corrective-action-almaha-modal.component.scss'],
  providers: [RilrService]
})
export class CorrectiveActionAlmahaModalComponent implements OnInit {

  public masterData: any = {};
  public company: Array<IOption> = [];
  public priorityArr: Array<IOption> = [];
  public actionAreaSelectionArr: Array<IOption> = [];
  public departmentArr: Array<IOption> = [];
  colorTheme = 'theme-blue';
  bsConfig: Partial<BsDatepickerConfig>;
  bsValue = new Date();
  isEdit: number;
  reportID: number;
  documentSystemID: number;
  public policyBaseAction: number = 0;
  public myActionBase: number = 0;
  @ViewChild('swalModal') swalModal: any;
  @ViewChild('errorMessageHtml') errorMessageHtml: any;
  @ViewChild('f') form: any;

  public repeatedActionID: number = 0;
  public successMsg: string = '';
  public htmlErrorMessage: string = "";

  public employeeOption: Array<IOption> = [];
  public companySystemID = +this.helperService.getSelectedCompanyId();

  public actionAssignedArr: any = [
    {value: 1, label: 'Individual'},
    {value: 2, label: 'Department'}
  ];

  public yesNoArr: any = [
    {value: 0, label: 'Open'},
    {value: 1, label: 'In Progress'},
    {value: 2, label: 'Closed'}
  ];

  public repeatedArr: any = [
    {value: 1, label: 'New'},
    {value: 2, label: 'Repeated'},
  ];
  public fileChanges: boolean = false;
  public attachments: any = [];
  public submitted: boolean = false;
  constructor(public bsModalRef: BsModalRef,
              private rilrService: RilrService,
              private spinner: NgxSpinnerService,
              private helperService: HelperService,
              private location: Location,
              private modalService: BsModalService) {
    this.bsConfig = Object.assign({}, {containerClass: this.colorTheme, dateInputFormat: 'DD/MM/YYYY'});
    this.masterData.IncidateDate = this.bsValue;
  }

  ngOnInit() {
    this.editFormLoad();
  }

  editFormLoad() {
    setTimeout(() => {
      if (this.isEdit == 1) {
        this.getEmployees(this.masterData.personResEmpID);
        this.masterData.submitted = this.helperService.setSelectedValue(this.masterData.submitted);
      }
    }, 0);
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason('corrective_action_closed');
  }

  closeSuccessModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason('corrective_action_success');
  }

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  showSuccessHtml() {
    setTimeout(() => {
      this.swalModal.show();
    }, 0);
  }

  public typehead(value: any): void {
    if (value.length > 0) {
      this.getEmployees(value);
    } else {
      this.employeeOption = [];
    }
  }

  getEmployees(value: any) {
    const that = this;
    that.rilrService
      .getTypeheadEmployees()
      .get({
        'search': value,
        'companySystemID': that.companySystemID
      })
      .subscribe(resp => {
        var tempOption = resp.data.data;
        that.employeeOption = [];
        that.employeeOption = that.helperService.setSelect2DropDownOptionsConcatLabelThree(tempOption, "employeeSystemID", "empName", "countryName", "description");
        if (that.isEdit == 1) {
          setTimeout(() => {
            that.masterData.personResEmpSystemID = that.helperService.setSelectedValue(that.masterData.personResEmpSystemID);
          }, 0);
        }
      }, (err) => {
        //console.log(err);
        that.employeeOption = [];
      });
  }

  storeCorrectiveAction() {
    const that = this;
    const tempArray = {};
    that.spinner.show();
    that.masterData.reportSystemID = that.reportID;
    that.masterData.companySystemID = that.companySystemID;
    that.masterData.documentSystemID = that.documentSystemID;
    that.masterData.host = window.location.origin;
    that.masterData.policyBaseAction = that.policyBaseAction;
    that.masterData.masterType = 1;
    that.masterData.targetDate = that.helperService.formatDate(that.masterData.targetDate);
    that.masterData.expectedCompletionDate = that.helperService.formatDate(that.masterData.expectedCompletionDate);
    tempArray['master'] = that.masterData;
    tempArray['attachments'] = that.attachments;
    that.rilrService
      .reportCorrectiveActionsStoreAlMaha()
      .post(tempArray)
      .subscribe(resp => {
        that.masterData = {};
        that.successMsg = "";
        if (that.isEdit === 1) {
          that.successMsg = "Successfully updated corrective action";
        } else if (that.isEdit === 0) {
          that.successMsg = "Successfully added corrective action";
        }
        that.showSuccessHtml();
        that.closeSuccessModal();
        that.spinner.hide();
      }, (error) => {
        that.htmlErrorMessage = "";
        if (error.status === 500) {
          that.htmlErrorMessage = error.data.message;
          that.showErrorHtml();
        } else if (error.status === 422) {
          that.htmlErrorMessage = that.helperService.serverSideError422(error.data.message);
          that.showErrorHtml();
        }
        that.spinner.hide();
      });
  }

  public repeatedActionChange(ID) {
    if (ID == 2) {
      this.masterData.priorityID = this.helperService.setSelectedValue(8);
    } else {
      this.masterData.priorityID = this.helperService.setSelectedValue(0);
    }
  }

  public priorityActionChange(priorityID) {
    if (this.repeatedActionID > 0 && priorityID == 7) {
      this.masterData.priorityID = this.helperService.setSelectedValue(8);
    }
  }

  public createAction() {
    if (this.form.form.valid) {
      this.submit();
    }
  }

  public addAttachment(list) {
    this.attachments = list;
    this.storeCorrectiveAction();
  }

  public submit() {
    if (!this.submitted) {
      this.fileChanges = !this.fileChanges;
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/corrective-action-almaha-modal/corrective-action-almaha-modal.component.ts